import { PriceCalcFailedReason } from "types";

/**
 * Deutsche Beschriftung eines Fehlergrunds. `null` steht für eine Karte, die
 * fehlgeschlagen ist, ohne einen Grund hinterlassen zu haben - typischerweise,
 * weil sie in einem abgebrochenen oder in den Timeout gelaufenen Lauf nie
 * bearbeitet wurde.
 */
export const getPriceCalcFailedReasonName = (
  value: PriceCalcFailedReason | null | undefined,
): string => {
  switch (value) {
    case "NoArticlesFound":
      return "Keine verwertbaren Angebote auf dem Markt gefunden";
    case "NoStockArticlesFound":
      return "Keine Bestandsartikel gefunden";
    case "ApiRequestFailed":
      return "Cardmarket-Abruf fehlgeschlagen - eine Neuberechnung kann helfen";
    case "CalculationError":
      return "Fehler bei der Berechnung";
    case "Cancelled":
      return "Durch einen Abbruch übersprungen";
    default:
      return "Noch nicht berechnet";
  }
};

/**
 * Gründe, bei denen eine Neuberechnung nichts ändert, werden gedämpft
 * dargestellt - die anderen laden zum erneuten Versuch ein.
 */
export const getPriceCalcFailedReasonColor = (
  value: PriceCalcFailedReason | null | undefined,
): "red" | "orange" | "grey" => {
  switch (value) {
    case "NoArticlesFound":
      return "grey";
    case "ApiRequestFailed":
    case "CalculationError":
      return "red";
    default:
      return "orange";
  }
};
